<script>
	module.exports = {
		modelData: ['forceAccountChooser']
	};
</script>
<template>
	<main
		id="content"
		class="main"
		role="main">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Shared Device Management</h1>
			</div>
		</header>
		<div class="main-content wrapper rte">
			<p><strong>You need to adjust this setting from the device your students are sharing.</strong></p>
			<p>On this device, should students be forced to use the Google Account Chooser?</p>
			<div>
				<label
					style="cursor: pointer"
					for="force-account-chooser">
					<input
						id="force-account-chooser"
						v-model="forceAccountChooser"
						type="checkbox" />&nbsp;Force Google Account Chooser</label
				>
			</div>
		</div>
	</main>
</template>
